/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.BLACKBERRY_MODELS = {
    '9000'      : 'Bold',
    '9600'      : 'Bold',
    '9650'      : 'Bold',
    '9700'      : 'Bold',
    '9780'      : 'Bold',
    '9788'      : 'Bold',
    '9790'      : 'Bold',
    '9900'      : 'Bold',
    '9930'      : 'Bold',
    '8300'      : 'Curve',
    '8310'      : 'Curve',
    '8320'      : 'Curve',
    '8330'      : 'Curve',
    '8350i'     : 'Curve',
    '8520'      : 'Curve',
    '8530'      : 'Curve',
    '8900'      : 'Curve',
    '9220'      : 'Curve',
    '9300'      : 'Curve',
    '9310'      : 'Curve',
    '9315'      : 'Curve',
    '9320'      : 'Curve',
    '9330'      : 'Curve',
    '9350'      : 'Curve',
    '9360'      : 'Curve',
    '9370'      : 'Curve',
    '9380'      : 'Curve',
    '8100'      : 'Pearl',
    '8110'      : 'Pearl',
    '8120'      : 'Pearl',
    '8130'      : 'Pearl',
    '8220'      : 'Pearl',
    '8230'      : 'Pearl',
    '9100'      : 'Pearl',
    '9105'      : 'Pearl',
    '9500'      : 'Storm',
    '9520'      : 'Storm2',
    '9530'      : 'Storm',
    '9550'      : 'Storm',
    '9670'      : 'Style',
    '9800'      : 'Torch',
    '9810'      : 'Torch',
    '9850'      : 'Torch',
    '9860'      : 'Torch',
    '9630'      : 'Tour',
    '9981'      : 'Porsche P'
};

/* This file is automatically generated, do not edit manually! */
